export const LOCKER_SCROLL_OFFSET = 20;
